import React, { useState, useEffect } from "react";
import "./DesignAPage.css";

// ─── Design tokens / sample data ────────────────────────────
const USER = {
  name: "지유",
  streak: 12,
  goalMin: 20,
  todayMin: 14,
  goalProblems: 30,
  todayProblems: 18,
  totalWords: 1284,
  accuracy: 87,
  reviewDue: 23,
};


const CONCEPTS = [
  { id: "c1", ko: "A vs B 비교",  desc: "두 단어의 차이를 직접 비교",  kind: "versus" as const },
  { id: "c2", ko: "빈칸 채우기",   desc: "문맥 속에서 정확한 단어 선택", kind: "blank"  as const },
  { id: "c3", ko: "1D 뉘앙스",    desc: "한 축 위 감정 강도 정렬",    kind: "line1d" as const },
  { id: "c4", ko: "2D 뉘앙스",    desc: "두 축 평면에 단어 배치",     kind: "grid2d" as const },
];

// ─── Icons ────────────────────────────────────────────────────
const Icons = {
  book: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h11a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3V4z"/>
      <path d="M4 17a3 3 0 0 1 3-3h11"/>
    </svg>
  ),
  spark: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v5M12 16v5M3 12h5M16 12h5M5.5 5.5l3.5 3.5M15 15l3.5 3.5M5.5 18.5l3.5-3.5M15 9l3.5-3.5"/>
    </svg>
  ),
  heart: ({ s = 20, c = "currentColor", fill = "none" }: { s?: number; c?: string; fill?: string }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill={fill} stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/>
    </svg>
  ),
  flame: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3c1 3 4 4.5 4 8a4 4 0 1 1-8 0c0-1.5.5-2.5 1.5-3.5C10.5 8 10 5.5 12 3z"/>
      <path d="M10.5 16a2 2 0 1 0 3 0"/>
    </svg>
  ),
  home: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 10l8-6 8 6v10a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1V10z"/>
    </svg>
  ),
  play: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill={c} stroke="none">
      <path d="M7 4.5v15l13-7.5z"/>
    </svg>
  ),
  arrow: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M13 6l6 6-6 6"/>
    </svg>
  ),
  plus: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round">
      <path d="M12 5v14M5 12h14"/>
    </svg>
  ),
  user: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/>
    </svg>
  ),
  grid2d: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 20h18M12 3v17"/>
      <circle cx="7" cy="15" r="1.4" fill={c}/>
      <circle cx="15" cy="8" r="1.4" fill={c}/>
      <circle cx="17" cy="16" r="1.4" fill={c}/>
    </svg>
  ),
  line1d: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12h18"/>
      <circle cx="7" cy="12" r="1.6" fill={c}/>
      <circle cx="13" cy="12" r="1.6" fill={c}/>
      <circle cx="19" cy="12" r="1.6" fill={c}/>
    </svg>
  ),
  blank: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="6" width="18" height="12" rx="2"/>
      <path d="M8 12h2M14 12h2" strokeDasharray="0 3"/>
    </svg>
  ),
  versus: ({ s = 20, c = "currentColor" }) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="7" height="14" rx="1.5"/>
      <rect x="14" y="5" width="7" height="14" rx="1.5"/>
    </svg>
  ),
};


// ─── Blobs ────────────────────────────────────────────────────
function Blobs() {
  return (
    <div style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}>
      <div style={{ position: "absolute", top: "-10%", right: "-20%", width: 380, height: 380, borderRadius: "50%", background: "var(--blob-lilac)", filter: "blur(70px)", opacity: 0.55 }}/>
      <div style={{ position: "absolute", bottom: "-15%", left: "-10%", width: 340, height: 340, borderRadius: "50%", background: "var(--blob-lilac)", filter: "blur(70px)", opacity: 0.4 }}/>
    </div>
  );
}

// ─── AppBar ───────────────────────────────────────────────────
function AppBar({ platform }: { platform: "ios" | "android" }) {
  const top = platform === "android" ? 36 : 54;
  return (
    <div style={{ position: "absolute", top, left: 12, right: 12, zIndex: 20, display: "flex", alignItems: "center", justifyContent: "space-between", pointerEvents: "none" }}>
      <div style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "6px 12px 6px 10px", borderRadius: 999, pointerEvents: "auto",
        background: "rgba(255,255,255,0.55)", backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        border: "0.5px solid rgba(255,255,255,0.7)",
        boxShadow: "inset 1px 1px 0 rgba(255,255,255,0.7), 0 2px 8px rgba(50,30,80,0.05)",
      }}>
        <div style={{
          width: 20, height: 20, borderRadius: 6,
          background: "linear-gradient(135deg, var(--accent) 0%, oklch(0.48 0.19 300) 100%)",
          display: "grid", placeItems: "center", color: "white", fontSize: 11, fontWeight: 700,
          fontFamily: "var(--font-sans)", letterSpacing: "-0.03em",
          boxShadow: "inset 1px 1px 0 rgba(255,255,255,0.3), 0 1px 3px rgba(120,80,200,0.3)",
        }}>G</div>
        <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--ink-0)", letterSpacing: "-0.02em", fontFamily: "var(--font-sans)" }}>
          Gang<span style={{ color: "var(--accent-ink)" }}>-Z</span>
        </div>
      </div>
    </div>
  );
}

// ─── Progress Ring ────────────────────────────────────────────
function ProgressRing({ value, size = 86, strokeW = 7 }: { value: number; size?: number; strokeW?: number }) {
  const r = (size - strokeW) / 2;
  const c = 2 * Math.PI * r;
  const [animated, setAnimated] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setAnimated(value), 50);
    return () => clearTimeout(t);
  }, [value]);
  const dash = c * (animated / 100);
  return (
    <div style={{ width: size, height: size, position: "relative", display: "grid", placeItems: "center", flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(90,70,140,0.12)" strokeWidth={strokeW}/>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--accent)" strokeWidth={strokeW}
          strokeLinecap="round" strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 900ms cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", lineHeight: 1 }}>
        <div style={{ textAlign: "center" }}>
          <div className="da-num" style={{ fontSize: 22, fontWeight: 600, color: "var(--ink-0)" }}>
            {value}<span style={{ fontSize: 11, color: "var(--ink-2)", marginLeft: 1 }}>%</span>
          </div>
          <div style={{ fontSize: 9, color: "var(--ink-2)", marginTop: 3, letterSpacing: "0.1em", textTransform: "uppercase" }}>GOAL</div>
        </div>
      </div>
    </div>
  );
}

// ─── Section Header ───────────────────────────────────────────
function SectionHeader({ title, action }: { title: string; action?: React.ReactNode }) {
  return (
    <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", padding: "4px 18px 10px" }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink-0)", letterSpacing: "-0.01em" }}>{title}</div>
      {action && <div style={{ fontSize: 12, color: "var(--ink-1)", fontWeight: 500 }}>{action}</div>}
    </div>
  );
}

// ─── Concept Tile ─────────────────────────────────────────────
function ConceptTile({ c, i }: { c: typeof CONCEPTS[0]; i: number }) {
  const IconEl = Icons[c.kind as keyof typeof Icons] || Icons.book;
  const gradients = [
    "linear-gradient(135deg, oklch(0.96 0.04 30), oklch(0.95 0.04 355))",
    "linear-gradient(135deg, oklch(0.96 0.04 185), oklch(0.95 0.04 200))",
    "linear-gradient(135deg, oklch(0.96 0.04 290), oklch(0.95 0.04 305))",
    "linear-gradient(135deg, oklch(0.96 0.04 130), oklch(0.95 0.04 100))",
  ];
  return (
    <div style={{
      borderRadius: "var(--r-lg)", padding: "12px 12px 10px",
      position: "relative", cursor: "pointer", minHeight: 84, overflow: "hidden",
      background: gradients[i % gradients.length],
      border: "1px solid rgba(255,255,255,0.85)",
      boxShadow: "0 2px 8px rgba(80,60,140,0.08), inset 1px 1px 0 rgba(255,255,255,0.9)",
      display: "flex", alignItems: "center", gap: 10,
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: 9,
        background: "rgba(255,255,255,0.78)", color: "var(--ink-0)",
        display: "grid", placeItems: "center",
        border: "0.5px solid rgba(255,255,255,0.9)",
        boxShadow: "inset 1px 1px 0 rgba(255,255,255,0.9)", flexShrink: 0,
      }}>
        <IconEl s={15} />
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--ink-0)", letterSpacing: "-0.01em", lineHeight: 1.15 }}>{c.ko}</div>
        <div style={{ fontSize: 10.5, color: "var(--ink-1)", marginTop: 2, lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.desc}</div>
      </div>
    </div>
  );
}

// ─── Inline Review CTA ────────────────────────────────────────
function InlineReviewCTA() {
  return (
    <div className="da-glass da-glass-sheen" style={{ borderRadius: "var(--r-lg)", padding: "16px 16px", display: "flex", alignItems: "center", gap: 14 }}>
      <div style={{
        width: 44, height: 44, borderRadius: "50%",
        background: "var(--accent)", color: "white",
        display: "grid", placeItems: "center",
        boxShadow: "0 4px 12px rgba(120,80,200,0.35)", flexShrink: 0,
      }}>
        {Icons.play({ s: 16, c: "white" })}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink-0)", letterSpacing: "-0.01em" }}>복습 시작</div>
        <div style={{ fontSize: 12, color: "var(--ink-2)", marginTop: 2 }}>{USER.reviewDue}개 단어가 기다리고 있어요</div>
      </div>
      <div style={{
        width: 30, height: 30, borderRadius: "50%",
        background: "rgba(255,255,255,0.6)", border: "0.5px solid rgba(0,0,0,0.05)",
        display: "grid", placeItems: "center", color: "var(--ink-1)", flexShrink: 0,
      }}>
        {Icons.arrow({ s: 14 })}
      </div>
    </div>
  );
}

// ─── Bottom Tab Bar ───────────────────────────────────────────
function BottomTabBar({ platform, active = "home" }: { platform: "ios" | "android"; active?: string }) {
  const tabs = [
    { key: "home",  Icon: Icons.home,  label: "홈" },
    { key: "voca",  Icon: Icons.book,  label: "단어장" },
    { key: "study", Icon: Icons.spark, label: "학습" },
    { key: "my",    Icon: Icons.user,  label: "마이" },
  ];
  const isAndroid = platform === "android";
  return (
    <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: isAndroid ? "8px 12px 10px" : "8px 12px 30px", zIndex: 10 }}>
      <div className="da-glass-strong" style={{ borderRadius: 28, padding: "6px", display: "flex", justifyContent: "space-around" }}>
        {tabs.map((t) => (
          <div key={t.key} style={{
            flex: 1, display: "flex", flexDirection: "column",
            alignItems: "center", gap: 2, padding: "8px 4px",
            borderRadius: 22,
            background: t.key === active ? "rgba(255,255,255,0.7)" : "transparent",
            color: t.key === active ? "var(--accent-ink)" : "var(--ink-2)",
            fontWeight: t.key === active ? 600 : 500,
          }}>
            <t.Icon s={20} />
            <div style={{ fontSize: 10.5, letterSpacing: "-0.01em" }}>{t.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Variant A — Calm Glass Dashboard ────────────────────────
function VariantA({ platform }: { platform: "ios" | "android" }) {
  const pct = Math.round((USER.todayProblems / USER.goalProblems) * 100);
  const isAndroid = platform === "android";
  const topPad = isAndroid ? 92 : 108;
  const bottomPad = isAndroid ? 90 : 100;

  return (
    <div style={{
      position: "relative", width: "100%", height: "100%",
      overflow: "hidden", color: "var(--ink-0)",
      background: "var(--bg-0)", fontFamily: "var(--font-sans)",
    }}>
      <Blobs />
      <AppBar platform={platform} />

      <div className="da-device-scroll" style={{ position: "absolute", inset: 0, overflow: "auto", paddingTop: topPad, paddingBottom: bottomPad }}>
        {/* Hero card */}
        <div style={{ padding: "8px 16px 16px" }}>
          <div className="da-glass da-glass-sheen" style={{ borderRadius: "var(--r-xl)", padding: "20px 20px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 500, color: "var(--ink-2)", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                  4월 19일 · 토요일
                </div>
                <div style={{ fontFamily: "var(--font-sans)", fontSize: 24, fontWeight: 700, lineHeight: 1.18, marginTop: 4, color: "var(--ink-0)", letterSpacing: "-0.025em" }}>
                  안녕, {USER.name}<br/>
                  <span style={{ color: "var(--ink-1)" }}>오늘 {USER.goalProblems - USER.todayProblems}문제 남았어요</span>
                </div>
                <div style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 10, padding: "3px 9px", borderRadius: 999, background: "var(--accent-soft)", color: "var(--accent-ink)", fontWeight: 500, fontSize: 12 }}>
                  {Icons.flame({ s: 13 })} {USER.streak}일 연속
                </div>
              </div>
              <ProgressRing value={pct} size={86} strokeW={7} />
            </div>
          </div>
        </div>

        <SectionHeader title="학습 모드" />

        <div style={{ padding: "0 16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {CONCEPTS.map((c, i) => <ConceptTile key={c.id} c={c} i={i} />)}
        </div>

        <div style={{ height: 22 }} />
        <SectionHeader title="복습" action={<span style={{ color: "var(--ink-2)" }}>{USER.reviewDue}개 대기</span>} />
        <div style={{ padding: "0 16px" }}>
          <InlineReviewCTA />
        </div>
        <div style={{ height: 12 }} />
      </div>

      <BottomTabBar platform={platform} />
    </div>
  );
}

// ─── iOS Device Frame ─────────────────────────────────────────
function IOSStatusBar({ time = "9:41" }) {
  const c = "#000";
  return (
    <div style={{ display: "flex", gap: 154, alignItems: "center", justifyContent: "center", padding: "21px 24px 19px", boxSizing: "border-box", position: "relative", zIndex: 20, width: "100%" }}>
      <div style={{ flex: 1, height: 22, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 1.5 }}>
        <span style={{ fontFamily: "-apple-system, 'SF Pro', system-ui", fontWeight: 590, fontSize: 17, lineHeight: "22px", color: c }}>{time}</span>
      </div>
      <div style={{ flex: 1, height: 22, display: "flex", alignItems: "center", justifyContent: "center", gap: 7, paddingTop: 1, paddingRight: 1 }}>
        <svg width="19" height="12" viewBox="0 0 19 12">
          <rect x="0" y="7.5" width="3.2" height="4.5" rx="0.7" fill={c}/>
          <rect x="4.8" y="5" width="3.2" height="7" rx="0.7" fill={c}/>
          <rect x="9.6" y="2.5" width="3.2" height="9.5" rx="0.7" fill={c}/>
          <rect x="14.4" y="0" width="3.2" height="12" rx="0.7" fill={c}/>
        </svg>
        <svg width="17" height="12" viewBox="0 0 17 12">
          <path d="M8.5 3.2C10.8 3.2 12.9 4.1 14.4 5.6L15.5 4.5C13.7 2.7 11.2 1.5 8.5 1.5C5.8 1.5 3.3 2.7 1.5 4.5L2.6 5.6C4.1 4.1 6.2 3.2 8.5 3.2Z" fill={c}/>
          <path d="M8.5 6.8C9.9 6.8 11.1 7.3 12 8.2L13.1 7.1C11.8 5.9 10.2 5.1 8.5 5.1C6.8 5.1 5.2 5.9 3.9 7.1L5 8.2C5.9 7.3 7.1 6.8 8.5 6.8Z" fill={c}/>
          <circle cx="8.5" cy="10.5" r="1.5" fill={c}/>
        </svg>
        <svg width="27" height="13" viewBox="0 0 27 13">
          <rect x="0.5" y="0.5" width="23" height="12" rx="3.5" stroke={c} strokeOpacity="0.35" fill="none"/>
          <rect x="2" y="2" width="20" height="9" rx="2" fill={c}/>
          <path d="M25 4.5V8.5C25.8 8.2 26.5 7.2 26.5 6.5C26.5 5.8 25.8 4.8 25 4.5Z" fill={c} fillOpacity="0.4"/>
        </svg>
      </div>
    </div>
  );
}

function IOSDevice({ children, width = 390, height = 780 }: { children: React.ReactNode; width?: number; height?: number }) {
  return (
    <div style={{
      width, height, borderRadius: 48, overflow: "hidden", position: "relative",
      background: "#F2F2F7",
      boxShadow: "0 40px 80px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.12)",
      fontFamily: "-apple-system, system-ui, sans-serif",
      WebkitFontSmoothing: "antialiased",
    }}>
      {/* Dynamic Island */}
      <div style={{ position: "absolute", top: 11, left: "50%", transform: "translateX(-50%)", width: 126, height: 37, borderRadius: 24, background: "#000", zIndex: 50 }}/>
      {/* Status bar */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 10 }}>
        <IOSStatusBar />
      </div>
      {/* Content */}
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div style={{ flex: 1, overflow: "auto" }}>{children}</div>
      </div>
      {/* Home indicator */}
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, zIndex: 60, height: 34, display: "flex", justifyContent: "center", alignItems: "flex-end", paddingBottom: 8, pointerEvents: "none" }}>
        <div style={{ width: 139, height: 5, borderRadius: 100, background: "rgba(0,0,0,0.25)" }}/>
      </div>
    </div>
  );
}

// ─── Android Device Frame ─────────────────────────────────────
function AndroidStatusBar() {
  const c = "#000";
  return (
    <div style={{ height: 40, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 16px", position: "relative", fontFamily: "system-ui, sans-serif", background: "transparent" }}>
      <div style={{ width: 128, display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 400, letterSpacing: 0.25, lineHeight: "20px", color: c }}>9:30</span>
      </div>
      <div style={{ position: "absolute", left: "50%", top: 8, transform: "translateX(-50%)", width: 24, height: 24, borderRadius: 100, background: "#2e2e2e" }}/>
      <div style={{ display: "flex", alignItems: "center" }}>
        <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 2 }}>
          <path d="M8 13.3L.67 5.97a10.37 10.37 0 0114.66 0L8 13.3z" fill={c}/>
        </svg>
        <svg width="16" height="16" viewBox="0 0 16 16">
          <rect x="3.75" y="2" width="8.5" height="13" rx="1.5" fill={c}/>
          <rect x="5.5" y="0.9" width="5" height="2" rx="0.5" fill={c}/>
        </svg>
      </div>
    </div>
  );
}

function AndroidDevice({ children, width = 400, height = 800 }: { children: React.ReactNode; width?: number; height?: number }) {
  return (
    <div style={{
      width, height, borderRadius: 36, overflow: "hidden",
      background: "#F2F2F7",
      border: "1px solid rgba(0,0,0,0.12)",
      boxShadow: "0 40px 80px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)",
      display: "flex", flexDirection: "column", boxSizing: "border-box",
    }}>
      <AndroidStatusBar />
      <div style={{ flex: 1, overflow: "auto" }}>{children}</div>
      <div style={{ height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: 108, height: 4, borderRadius: 2, background: "#171d1b", opacity: 0.4 }}/>
      </div>
    </div>
  );
}

// ─── Tweaks Panel ─────────────────────────────────────────────
interface TweakState { blur: number; alpha: number; sat: number; glass: boolean }

function TweaksPanel({ tweaks, onChange }: { tweaks: TweakState; onChange: (t: TweakState) => void }) {
  const [open, setOpen] = useState(false);
  const set = (patch: Partial<TweakState>) => onChange({ ...tweaks, ...patch });
  return (
    <>
      <button onClick={() => setOpen(v => !v)} style={{
        position: "fixed", right: 20, bottom: 20, zIndex: 1001,
        padding: "8px 16px", borderRadius: 999, border: "none",
        background: "var(--accent)", color: "white",
        fontFamily: "var(--font-sans)", fontSize: 13, fontWeight: 600,
        cursor: "pointer", boxShadow: "0 4px 16px rgba(120,80,200,0.4)",
      }}>Tweaks</button>

      {open && (
        <div style={{
          position: "fixed", right: 20, bottom: 68, zIndex: 1000, width: 280,
          background: "rgba(255,255,255,0.8)", backdropFilter: "blur(30px) saturate(180%)",
          WebkitBackdropFilter: "blur(30px) saturate(180%)",
          border: "0.5px solid rgba(255,255,255,0.8)", borderRadius: 20,
          boxShadow: "inset 1px 1px 0 rgba(255,255,255,0.8), 0 2px 6px rgba(0,0,0,0.06), 0 20px 60px rgba(0,0,0,0.15)",
          fontFamily: "var(--font-sans)", color: "var(--ink-0)", overflow: "hidden",
        }}>
          <div style={{ padding: "14px 16px 10px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "0.5px solid rgba(0,0,0,0.06)" }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>Tweaks</div>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--ink-2)" }}>GLASS</div>
          </div>
          <div style={{ padding: "14px 16px 16px", display: "flex", flexDirection: "column", gap: 14 }}>
            {[
              { label: "블러", id: "blur", min: 0, max: 60, val: tweaks.blur, unit: "px", key: "blur" as const },
              { label: "투명도", id: "alpha", min: 10, max: 90, val: tweaks.alpha, unit: "%", key: "alpha" as const },
              { label: "채도 증폭", id: "sat", min: 100, max: 250, val: tweaks.sat, unit: "%", key: "sat" as const },
            ].map(({ label, min, max, val, unit, key }) => (
              <div key={key} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <label style={{ display: "flex", justifyContent: "space-between", fontSize: 11, fontWeight: 500, color: "var(--ink-1)", letterSpacing: "0.03em" }}>
                  {label}
                  <span style={{ fontFamily: "var(--font-mono)", color: "var(--ink-0)", fontWeight: 600 }}>{val}{unit}</span>
                </label>
                <input type="range" min={min} max={max} step={key === "alpha" ? 5 : key === "sat" ? 10 : 1} value={val}
                  onChange={e => set({ [key]: +e.target.value } as Partial<TweakState>)}
                  style={{ WebkitAppearance: "none", appearance: "none", width: "100%", height: 4, borderRadius: 2, background: "rgba(0,0,0,0.1)", outline: "none" }}
                />
              </div>
            ))}
            <div onClick={() => set({ glass: !tweaks.glass })} style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "8px 10px", background: "rgba(0,0,0,0.03)", borderRadius: 10,
              fontSize: 12, fontWeight: 500, cursor: "pointer", userSelect: "none",
            }}>
              <span>글래스 효과</span>
              <div style={{
                width: 36, height: 20, borderRadius: 999, position: "relative",
                background: tweaks.glass ? "var(--accent)" : "rgba(0,0,0,0.15)",
                transition: "background 200ms",
              }}>
                <div style={{
                  position: "absolute", top: 2, width: 16, height: 16, borderRadius: "50%",
                  background: "white", boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                  transition: "left 200ms", left: tweaks.glass ? 18 : 2,
                }}/>
              </div>
            </div>
            <div style={{ fontSize: 10.5, color: "var(--ink-2)", lineHeight: 1.4, padding: "6px 10px", borderRadius: 8, background: "oklch(0.95 0.04 60 / 0.6)", border: "0.5px solid oklch(0.85 0.05 60 / 0.5)" }}>
              글래스를 끄면 불투명 카드 버전으로 전환됩니다.
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ─── Main Page ────────────────────────────────────────────────
export default function DesignAPage() {
  const [tweaks, setTweaks] = useState<TweakState>({ blur: 18, alpha: 35, sat: 160, glass: true });

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--glass-blur", `${tweaks.blur}px`);
    root.style.setProperty("--glass-alpha", `${tweaks.alpha / 100}`);
    root.style.setProperty("--glass-sat", `${tweaks.sat}%`);
    root.style.setProperty("--glass-enabled", tweaks.glass ? "1" : "0");
  }, [tweaks]);

  return (
    <div className={tweaks.glass ? "" : "da-glass-off"} style={{ minHeight: "100vh", fontFamily: "var(--font-sans)", color: "var(--ink-0)", WebkitFontSmoothing: "antialiased", letterSpacing: "-0.01em" }}>
      {/* Page background */}
      <div style={{
        position: "fixed", inset: 0, zIndex: -1,
        background: "radial-gradient(ellipse 900px 700px at 50% 20%, oklch(0.93 0.045 290) 0%, transparent 70%), oklch(0.97 0.005 290)",
      }}/>

      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", padding: "56px 32px 80px", boxSizing: "border-box" }}>
        {/* Heading */}
        <div style={{ width: "100%", maxWidth: 1100, margin: "0 auto 40px", display: "flex", alignItems: "baseline", gap: 14, flexWrap: "wrap" }}>
          <span style={{
            fontFamily: "var(--font-mono)", fontSize: 11, fontWeight: 600,
            letterSpacing: "0.1em", textTransform: "uppercase",
            color: "var(--accent-ink)", background: "var(--accent-soft)",
            padding: "4px 10px", borderRadius: 999,
          }}>A · Calm Glass</span>
          <span style={{ fontSize: 28, fontWeight: 700, letterSpacing: "-0.03em", color: "var(--ink-0)" }}>홈 대시보드</span>
          <p style={{ flex: "1 1 100%", fontSize: 13.5, color: "var(--ink-1)", lineHeight: 1.6, maxWidth: 640, margin: "4px 0 0" }}>
            차분한 유리 서피스 기반 홈 대시보드. 인사말 + 문제 진행률 링이 중심,
            학습 모드는 컬러 그라데이션 컴팩트 타일, 복습은 인라인 CTA 박스.
          </p>
        </div>

        {/* Device frames */}
        <div style={{ display: "flex", gap: 56, alignItems: "flex-start", justifyContent: "center", flexWrap: "wrap" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
            <IOSDevice width={390} height={780}>
              <div style={{ width: "100%", height: "100%", position: "relative" }}>
                <VariantA platform="ios" />
              </div>
            </IOSDevice>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--ink-2)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 500 }}>iOS</div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
            <AndroidDevice width={400} height={800}>
              <div style={{ width: "100%", height: "100%", position: "relative" }}>
                <VariantA platform="android" />
              </div>
            </AndroidDevice>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--ink-2)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 500 }}>Android</div>
          </div>
        </div>
      </div>

      <TweaksPanel tweaks={tweaks} onChange={setTweaks} />
    </div>
  );
}
